// Export an empty array that will be populated with match data
export const matches = [
  {
    id: "m1",
    teams: {
      home: {
        name: "Kolkata Knight Riders",
        code: "KKR",
        logo: "/team_logos/kkr.jpeg",
      },
      away: {
        name: "Royal Challengers Bengaluru",
        code: "RCB",
        logo: "/team_logos/rcb.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Eden Gardens, Kolkata",
    startTime: "Sat Mar 22 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Match abandoned due to rain",
    scores: {
      home: "7/0 (1)",
      away: null,
    },
    fantasy: {
      contestCount: 40,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 35000,
      percentageJoined: 90,
      isHotMatch: true,
    },
  },
  {
    id: "m2",
    teams: {
      home: {
        name: "Sunrisers Hyderabad",
        code: "SRH",
        logo: "/team_logos/srh.jpeg",
      },
      away: {
        name: "Rajasthan Royals",
        code: "RR",
        logo: "/team_logos/rr.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Rajiv Gandhi International Cricket Stadium, Hyderabad",
    startTime: "Sun Mar 23 2025 15:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Sunrisers Hyderabad won by 44 runs",
    scores: {
      home: "180/5 (20)",
      away: "136/8 (20)",
    },
    fantasy: {
      contestCount: 35,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 30000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m3",
    teams: {
      home: {
        name: "Chennai Super Kings",
        code: "CSK",
        logo: "/team_logos/csk.jpeg",
      },
      away: {
        name: "Mumbai Indians",
        code: "MI",
        logo: "/team_logos/mi.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "MA Chidambaram Stadium, Chennai",
    startTime: "Sun Mar 23 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Mumbai Indians won by 54 runs",
    scores: {
      home: "120/7 (20)",
      away: "174/6 (20)",
    },
    fantasy: {
      contestCount: 45,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 40000,
      percentageJoined: 95,
      isHotMatch: true,
    },
  },
  {
    id: "m4",
    teams: {
      home: {
        name: "Delhi Capitals",
        code: "DC",
        logo: "/team_logos/dc.jpeg",
      },
      away: {
        name: "Lucknow Super Giants",
        code: "LSG",
        logo: "/team_logos/lsg.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Dr. Y.S. Rajasekhara Reddy ACA-VDCA Cricket Stadium, Visakhapatnam",
    startTime: "Mon Mar 24 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Delhi Capitals won by 6 wickets",
    scores: {
      home: "165/4 (18.2)",
      away: "162/7 (20)",
    },
    fantasy: {
      contestCount: 30,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 25000,
      percentageJoined: 80,
      isHotMatch: false,
    },
  },
  {
    id: "m5",
    teams: {
      home: {
        name: "Punjab Kings",
        code: "PBKS",
        logo: "/team_logos/pbks.jpeg",
      },
      away: {
        name: "Gujarat Titans",
        code: "GT",
        logo: "/team_logos/gt.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "New PCA Stadium, Chandigarh",
    startTime: "Tue Mar 25 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Gujarat Titans won by 3 wickets",
    scores: {
      home: "148/6 (20)",
      away: "149/7 (19.4)",
    },
    fantasy: {
      contestCount: 28,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 22000,
      percentageJoined: 75,
      isHotMatch: false,
    },
  },
  {
    id: "m6",
    teams: {
      home: {
        name: "Rajasthan Royals",
        code: "RR",
        logo: "/team_logos/rr.jpeg",
      },
      away: {
        name: "Kolkata Knight Riders",
        code: "KKR",
        logo: "/team_logos/kkr.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Barsapara Cricket Stadium, Guwahati",
    startTime: "Wed Mar 26 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Kolkata Knight Riders won by 7 wickets",
    scores: {
      home: "155/8 (20)",
      away: "156/3 (18.1)",
    },
    fantasy: {
      contestCount: 32,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 28000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m7",
    teams: {
      home: {
        name: "Sunrisers Hyderabad",
        code: "SRH",
        logo: "/team_logos/srh.jpeg",
      },
      away: {
        name: "Lucknow Super Giants",
        code: "LSG",
        logo: "/team_logos/lsg.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Rajiv Gandhi International Cricket Stadium, Hyderabad",
    startTime: "Thu Mar 27 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Sunrisers Hyderabad won by 22 runs",
    scores: {
      home: "188/4 (20)",
      away: "166/9 (20)",
    },
    fantasy: {
      contestCount: 30,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 26000,
      percentageJoined: 80,
      isHotMatch: false,
    },
  },
  {
    id: "m8",
    teams: {
      home: {
        name: "Royal Challengers Bengaluru",
        code: "RCB",
        logo: "/team_logos/rcb.jpeg",
      },
      away: {
        name: "Chennai Super Kings",
        code: "CSK",
        logo: "/team_logos/csk.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "M Chinnaswamy Stadium, Bengaluru",
    startTime: "Fri Mar 28 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Royal Challengers Bengaluru won by 6 wickets",
    scores: {
      home: "171/4 (19.1)",
      away: "170/6 (20)",
    },
    fantasy: {
      contestCount: 42,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 38000,
      percentageJoined: 92,
      isHotMatch: true,
    },
  },
  {
    id: "m9",
    teams: {
      home: {
        name: "Gujarat Titans",
        code: "GT",
        logo: "/team_logos/gt.jpeg",
      },
      away: {
        name: "Mumbai Indians",
        code: "MI",
        logo: "/team_logos/mi.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Narendra Modi Stadium, Ahmedabad",
    startTime: "Sat Mar 29 2025 15:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Mumbai Indians won by 8 wickets",
    scores: {
      home: "145/7 (20)",
      away: "146/2 (16.3)",
    },
    fantasy: {
      contestCount: 34,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 29000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m10",
    teams: {
      home: {
        name: "Delhi Capitals",
        code: "DC",
        logo: "/team_logos/dc.jpeg",
      },
      away: {
        name: "Sunrisers Hyderabad",
        code: "SRH",
        logo: "/team_logos/srh.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Dr. Y.S. Rajasekhara Reddy ACA-VDCA Cricket Stadium, Visakhapatnam",
    startTime: "Sat Mar 29 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Sunrisers Hyderabad won by 44 runs",
    scores: {
      home: "132/9 (20)",
      away: "176/5 (20)",
    },
    fantasy: {
      contestCount: 30,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 25000,
      percentageJoined: 80,
      isHotMatch: false,
    },
  },
  {
    id: "m11",
    teams: {
      home: {
        name: "Rajasthan Royals",
        code: "RR",
        logo: "/team_logos/rr.jpeg",
      },
      away: {
        name: "Chennai Super Kings",
        code: "CSK",
        logo: "/team_logos/csk.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Barsapara Cricket Stadium, Guwahati",
    startTime: "Sun Mar 30 2025 15:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Rajasthan Royals won by 5 wickets",
    scores: {
      home: "160/5 (19.2)",
      away: "159/6 (20)",
    },
    fantasy: {
      contestCount: 36,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 31000,
      percentageJoined: 88,
      isHotMatch: true,
    },
  },
  {
    id: "m12",
    teams: {
      home: {
        name: "Kolkata Knight Riders",
        code: "KKR",
        logo: "/team_logos/kkr.jpeg",
      },
      away: {
        name: "Mumbai Indians",
        code: "MI",
        logo: "/team_logos/mi.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Eden Gardens, Kolkata",
    startTime: "Sun Mar 30 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Kolkata Knight Riders won by 4 wickets",
    scores: {
      home: "178/6 (19.5)",
      away: "177/5 (20)",
    },
    fantasy: {
      contestCount: 38,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 34000,
      percentageJoined: 90,
      isHotMatch: true,
    },
  },
  {
    id: "m13",
    teams: {
      home: {
        name: "Lucknow Super Giants",
        code: "LSG",
        logo: "/team_logos/lsg.jpeg",
      },
      away: {
        name: "Punjab Kings",
        code: "PBKS",
        logo: "/team_logos/pbks.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "BRSABV Ekana Cricket Stadium, Lucknow",
    startTime: "Mon Mar 31 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Punjab Kings won by 12 runs",
    scores: {
      home: "150/8 (20)",
      away: "162/6 (20)",
    },
    fantasy: {
      contestCount: 30,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 26000,
      percentageJoined: 80,
      isHotMatch: false,
    },
  },
  {
    id: "m14",
    teams: {
      home: {
        name: "Royal Challengers Bengaluru",
        code: "RCB",
        logo: "/team_logos/rcb.jpeg",
      },
      away: {
        name: "Gujarat Titans",
        code: "GT",
        logo: "/team_logos/gt.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "M Chinnaswamy Stadium, Bengaluru",
    startTime: "Tue Apr 01 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Royal Challengers Bengaluru won by 6 wickets",
    scores: {
      home: "152/4 (18.4)",
      away: "151/7 (20)",
    },
    fantasy: {
      contestCount: 34,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 29000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m15",
    teams: {
      home: {
        name: "Kolkata Knight Riders",
        code: "KKR",
        logo: "/team_logos/kkr.jpeg",
      },
      away: {
        name: "Sunrisers Hyderabad",
        code: "SRH",
        logo: "/team_logos/srh.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Eden Gardens, Kolkata",
    startTime: "Wed Apr 02 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Kolkata Knight Riders won by 15 runs",
    scores: {
      home: "185/5 (20)",
      away: "170/6 (20)",
    },
    fantasy: {
      contestCount: 36,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 31000,
      percentageJoined: 88,
      isHotMatch: true,
    },
  },
  {
    id: "m16",
    teams: {
      home: {
        name: "Lucknow Super Giants",
        code: "LSG",
        logo: "/team_logos/lsg.jpeg",
      },
      away: {
        name: "Mumbai Indians",
        code: "MI",
        logo: "/team_logos/mi.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "BRSABV Ekana Cricket Stadium, Lucknow",
    startTime: "Thu Apr 03 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Mumbai Indians won by 7 wickets",
    scores: {
      home: "143/8 (20)",
      away: "144/3 (17.5)",
    },
    fantasy: {
      contestCount: 32,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 28000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m17",
    teams: {
      home: {
        name: "Delhi Capitals",
        code: "DC",
        logo: "/team_logos/dc.jpeg",
      },
      away: {
        name: "Chennai Super Kings",
        code: "CSK",
        logo: "/team_logos/csk.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Arun Jaitley Stadium, Delhi",
    startTime: "Fri Apr 04 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Chennai Super Kings won by 5 wickets",
    scores: {
      home: "165/6 (20)",
      away: "166/5 (19.3)",
    },
    fantasy: {
      contestCount: 34,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 29000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m18",
    teams: {
      home: {
        name: "Rajasthan Royals",
        code: "RR",
        logo: "/team_logos/rr.jpeg",
      },
      away: {
        name: "Punjab Kings",
        code: "PBKS",
        logo: "/team_logos/pbks.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Sawai Mansingh Stadium, Jaipur",
    startTime: "Sat Apr 05 2025 15:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Rajasthan Royals won by 9 wickets",
    scores: {
      home: "130/1 (15.4)",
      away: "129/8 (20)",
    },
    fantasy: {
      contestCount: 30,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 26000,
      percentageJoined: 80,
      isHotMatch: false,
    },
  },
  {
    id: "m19",
    teams: {
      home: {
        name: "Sunrisers Hyderabad",
        code: "SRH",
        logo: "/team_logos/srh.jpeg",
      },
      away: {
        name: "Gujarat Titans",
        code: "GT",
        logo: "/team_logos/gt.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Rajiv Gandhi International Cricket Stadium, Hyderabad",
    startTime: "Sat Apr 05 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Sunrisers Hyderabad won by 6 wickets",
    scores: {
      home: "154/4 (18.3)",
      away: "153/7 (20)",
    },
    fantasy: {
      contestCount: 32,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 28000,
      percentageJoined: 85,
      isHotMatch: false,
    },
  },
  {
    id: "m20",
    teams: {
      home: {
        name: "Royal Challengers Bengaluru",
        code: "RCB",
        logo: "/team_logos/rcb.jpeg",
      },
      away: {
        name: "Mumbai Indians",
        code: "MI",
        logo: "/team_logos/mi.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "M Chinnaswamy Stadium, Bengaluru",
    startTime: "Sun Apr 06 2025 15:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Mumbai Indians won by 5 wickets",
    scores: {
      home: "182/5 (20)",
      away: "183/5 (19.2)",
    },
    fantasy: {
      contestCount: 40,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 35000,
      percentageJoined: 90,
      isHotMatch: true,
    },
  },
  {
    id: "m21",
    teams: {
      home: {
        name: "Lucknow Super Giants",
        code: "LSG",
        logo: "/team_logos/lsg.jpeg",
      },
      away: {
        name: "Kolkata Knight Riders",
        code: "KKR",
        logo: "/team_logos/kkr.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "BRSABV Ekana Cricket Stadium, Lucknow",
    startTime: "Sun Apr 06 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Kolkata Knight Riders won by 8 wickets",
    scores: {
      home: "135/9 (20)",
      away: "136/2 (16.1)",
    },
    fantasy: {
      contestCount: 34,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 29000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m22",
    teams: {
      home: {
        name: "Punjab Kings",
        code: "PBKS",
        logo: "/team_logos/pbks.jpeg",
      },
      away: {
        name: "Chennai Super Kings",
        code: "CSK",
        logo: "/team_logos/csk.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "New PCA Stadium, Chandigarh",
    startTime: "Mon Apr 07 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Chennai Super Kings won by 4 wickets",
    scores: {
      home: "168/5 (20)",
      away: "169/6 (19.4)",
    },
    fantasy: {
      contestCount: 32,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 28000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m23",
    teams: {
      home: {
        name: "Gujarat Titans",
        code: "GT",
        logo: "/team_logos/gt.jpeg",
      },
      away: {
        name: "Rajasthan Royals",
        code: "RR",
        logo: "/team_logos/rr.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Narendra Modi Stadium, Ahmedabad",
    startTime: "Tue Apr 08 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Rajasthan Royals won by 3 wickets",
    scores: {
      home: "175/6 (20)",
      away: "176/7 (19.5)",
    },
    fantasy: {
      contestCount: 30,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 26000,
      percentageJoined: 80,
      isHotMatch: false,
    },
  },
  {
    id: "m24",
    teams: {
      home: {
        name: "Royal Challengers Bengaluru",
        code: "RCB",
        logo: "/team_logos/rcb.jpeg",
      },
      away: {
        name: "Delhi Capitals",
        code: "DC",
        logo: "/team_logos/dc.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "M Chinnaswamy Stadium, Bengaluru",
    startTime: "Wed Apr 09 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Royal Challengers Bengaluru won by 6 wickets",
    scores: {
      home: "163/4 (18.2)",
      away: "162/8 (20)",
    },
    fantasy: {
      contestCount: 36,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 31000,
      percentageJoined: 88,
      isHotMatch: true,
    },
  },
  {
    id: "m25",
    teams: {
      home: {
        name: "Chennai Super Kings",
        code: "CSK",
        logo: "/team_logos/csk.jpeg",
      },
      away: {
        name: "Kolkata Knight Riders",
        code: "KKR",
        logo: "/team_logos/kkr.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "MA Chidambaram Stadium, Chennai",
    startTime: "Thu Apr 10 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Kolkata Knight Riders won by 6 wickets",
    scores: {
      home: "154/7 (20)",
      away: "155/4 (18.3)",
    },
    fantasy: {
      contestCount: 40,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 35000,
      percentageJoined: 90,
      isHotMatch: true,
    },
  },
  {
    id: "m26",
    teams: {
      home: {
        name: "Gujarat Titans",
        code: "GT",
        logo: "/team_logos/gt.jpeg",
      },
      away: {
        name: "Lucknow Super Giants",
        code: "LSG",
        logo: "/team_logos/lsg.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Narendra Modi Stadium, Ahmedabad",
    startTime: "Fri Apr 11 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Lucknow Super Giants won by 5 wickets",
    scores: {
      home: "160/6 (20)",
      away: "161/5 (19.1)",
    },
    fantasy: {
      contestCount: 30,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 26000,
      percentageJoined: 80,
      isHotMatch: false,
    },
  },
  {
    id: "m27",
    teams: {
      home: {
        name: "Punjab Kings",
        code: "PBKS",
        logo: "/team_logos/pbks.jpeg",
      },
      away: {
        name: "Sunrisers Hyderabad",
        code: "SRH",
        logo: "/team_logos/srh.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "New PCA Stadium, Chandigarh",
    startTime: "Sat Apr 12 2025 15:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Sunrisers Hyderabad won by 7 wickets",
    scores: {
      home: "145/8 (20)",
      away: "146/3 (17.4)",
    },
    fantasy: {
      contestCount: 32,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 28000,
      percentageJoined: 85,
      isHotMatch: false,
    },
  },
  {
    id: "m28",
    teams: {
      home: {
        name: "Rajasthan Royals",
        code: "RR",
        logo: "/team_logos/rr.jpeg",
      },
      away: {
        name: "Royal Challengers Bengaluru",
        code: "RCB",
        logo: "/team_logos/rcb.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Sawai Mansingh Stadium, Jaipur",
    startTime: "Sat Apr 12 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Rajasthan Royals won by 4 wickets",
    scores: {
      home: "172/6 (19.3)",
      away: "171/5 (20)",
    },
    fantasy: {
      contestCount: 38,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 34000,
      percentageJoined: 90,
      isHotMatch: true,
    },
  },
  {
    id: "m29",
    teams: {
      home: {
        name: "Mumbai Indians",
        code: "MI",
        logo: "/team_logos/mi.jpeg",
      },
      away: {
        name: "Delhi Capitals",
        code: "DC",
        logo: "/team_logos/dc.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Wankhede Stadium, Mumbai",
    startTime: "Sun Apr 13 2025 15:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Mumbai Indians won by 6 wickets",
    scores: {
      home: "158/4 (18.1)",
      away: "157/7 (20)",
    },
    fantasy: {
      contestCount: 36,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 31000,
      percentageJoined: 88,
      isHotMatch: true,
    },
  },
  {
    id: "m30",
    teams: {
      home: {
        name: "Lucknow Super Giants",
        code: "LSG",
        logo: "/team_logos/lsg.jpeg",
      },
      away: {
        name: "Chennai Super Kings",
        code: "CSK",
        logo: "/team_logos/csk.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "BRSABV Ekana Cricket Stadium, Lucknow",
    startTime: "Sun Apr 13 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Chennai Super Kings won by 8 wickets",
    scores: {
      home: "140/9 (20)",
      away: "141/2 (16.2)",
    },
    fantasy: {
      contestCount: 34,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 29000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m31",
    teams: {
      home: {
        name: "Punjab Kings",
        code: "PBKS",
        logo: "/team_logos/pbks.jpeg",
      },
      away: {
        name: "Kolkata Knight Riders",
        code: "KKR",
        logo: "/team_logos/kkr.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "New PCA Stadium, Chandigarh",
    startTime: "Mon Apr 14 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Kolkata Knight Riders won by 5 wickets",
    scores: {
      home: "165/6 (20)",
      away: "166/5 (19.1)",
    },
    fantasy: {
      contestCount: 32,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 28000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m32",
    teams: {
      home: {
        name: "Delhi Capitals",
        code: "DC",
        logo: "/team_logos/dc.jpeg",
      },
      away: {
        name: "Rajasthan Royals",
        code: "RR",
        logo: "/team_logos/rr.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Arun Jaitley Stadium, Delhi",
    startTime: "Tue Apr 15 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Rajasthan Royals won by 7 wickets",
    scores: {
      home: "148/8 (20)",
      away: "149/3 (17.3)",
    },
    fantasy: {
      contestCount: 30,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 26000,
      percentageJoined: 80,
      isHotMatch: false,
    },
  },
  {
    id: "m33",
    teams: {
      home: {
        name: "Sunrisers Hyderabad",
        code: "SRH",
        logo: "/team_logos/srh.jpeg",
      },
      away: {
        name: "Mumbai Indians",
        code: "MI",
        logo: "/team_logos/mi.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Rajiv Gandhi International Cricket Stadium, Hyderabad",
    startTime: "Wed Apr 16 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Mumbai Indians won by 4 wickets",
    scores: {
      home: "170/5 (20)",
      away: "171/6 (19.4)",
    },
    fantasy: {
      contestCount: 36,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 31000,
      percentageJoined: 88,
      isHotMatch: true,
    },
  },
  {
    id: "m34",
    teams: {
      home: {
        name: "Royal Challengers Bengaluru",
        code: "RCB",
        logo: "/team_logos/rcb.jpeg",
      },
      away: {
        name: "Punjab Kings",
        code: "PBKS",
        logo: "/team_logos/pbks.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "M Chinnaswamy Stadium, Bengaluru",
    startTime: "Thu Apr 17 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Royal Challengers Bengaluru won by 6 wickets",
    scores: {
      home: "175/4 (18.3)",
      away: "174/6 (20)",
    },
    fantasy: {
      contestCount: 34,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 29000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m35",
    teams: {
      home: {
        name: "Delhi Capitals",
        code: "DC",
        logo: "/team_logos/dc.jpeg",
      },
      away: {
        name: "Gujarat Titans",
        code: "GT",
        logo: "/team_logos/gt.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Arun Jaitley Stadium, Delhi",
    startTime: "Fri Apr 18 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Delhi Capitals won by 5 wickets",
    scores: {
      home: "150/5 (19.2)",
      away: "149/7 (20)",
    },
    fantasy: {
      contestCount: 30,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 26000,
      percentageJoined: 80,
      isHotMatch: false,
    },
  },
  {
    id: "m36",
    teams: {
      home: {
        name: "Lucknow Super Giants",
        code: "LSG",
        logo: "/team_logos/lsg.jpeg",
      },
      away: {
        name: "Rajasthan Royals",
        code: "RR",
        logo: "/team_logos/rr.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "BRSABV Ekana Cricket Stadium, Lucknow",
    startTime: "Sat Apr 19 2025 15:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Rajasthan Royals won by 6 wickets",
    scores: {
      home: "160/7 (20)",
      away: "161/4 (18.4)",
    },
    fantasy: {
      contestCount: 32,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 28000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m37",
    teams: {
      home: {
        name: "Punjab Kings",
        code: "PBKS",
        logo: "/team_logos/pbks.jpeg",
      },
      away: {
        name: "Royal Challengers Bengaluru",
        code: "RCB",
        logo: "/team_logos/rcb.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "New PCA Stadium, Chandigarh",
    startTime: "Sat Apr 19 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Royal Challengers Bengaluru won by 7 wickets",
    scores: {
      home: "155/8 (20)",
      away: "156/3 (17.2)",
    },
    fantasy: {
      contestCount: 34,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 29000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m38",
    teams: {
      home: {
        name: "Chennai Super Kings",
        code: "CSK",
        logo: "/team_logos/csk.jpeg",
      },
      away: {
        name: "Mumbai Indians",
        code: "MI",
        logo: "/team_logos/mi.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "MA Chidambaram Stadium, Chennai",
    startTime: "Sun Apr 20 2025 15:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Mumbai Indians won by 5 wickets",
    scores: {
      home: "176/4 (20)",
      away: "177/5 (19.3)",
    },
    fantasy: {
      contestCount: 45,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 40000,
      percentageJoined: 95,
      isHotMatch: true,
    },
  },
  {
    id: "m39",
    teams: {
      home: {
        name: "Gujarat Titans",
        code: "GT",
        logo: "/team_logos/gt.jpeg",
      },
      away: {
        name: "Kolkata Knight Riders",
        code: "KKR",
        logo: "/team_logos/kkr.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Narendra Modi Stadium, Ahmedabad",
    startTime: "Sun Apr 20 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Kolkata Knight Riders won by 6 wickets",
    scores: {
      home: "165/7 (20)",
      away: "166/4 (18.2)",
    },
    fantasy: {
      contestCount: 34,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 29000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m40",
    teams: {
      home: {
        name: "Lucknow Super Giants",
        code: "LSG",
        logo: "/team_logos/lsg.jpeg",
      },
      away: {
        name: "Delhi Capitals",
        code: "DC",
        logo: "/team_logos/dc.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "BRSABV Ekana Cricket Stadium, Lucknow",
    startTime: "Mon Apr 21 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Delhi Capitals won by 4 wickets",
    scores: {
      home: "170/6 (20)",
      away: "171/6 (19.4)",
    },
    fantasy: {
      contestCount: 30,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 26000,
      percentageJoined: 80,
      isHotMatch: false,
    },
  },
  {
    id: "m41",
    teams: {
      home: {
        name: "Sunrisers Hyderabad",
        code: "SRH",
        logo: "/team_logos/srh.jpeg",
      },
      away: {
        name: "Mumbai Indians",
        code: "MI",
        logo: "/team_logos/mi.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Rajiv Gandhi International Cricket Stadium, Hyderabad",
    startTime: "Tue Apr 22 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Mumbai Indians won by 7 wickets",
    scores: {
      home: "150/8 (20)",
      away: "151/3 (17.1)",
    },
    fantasy: {
      contestCount: 36,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 31000,
      percentageJoined: 88,
      isHotMatch: true,
    },
  },
  {
    id: "m42",
    teams: {
      home: {
        name: "Royal Challengers Bengaluru",
        code: "RCB",
        logo: "/team_logos/rcb.jpeg",
      },
      away: {
        name: "Rajasthan Royals",
        code: "RR",
        logo: "/team_logos/rr.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "M Chinnaswamy Stadium, Bengaluru",
    startTime: "Wed Apr 23 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Royal Challengers Bengaluru won by 5 wickets",
    scores: {
      home: "180/5 (19.2)",
      away: "179/6 (20)",
    },
    fantasy: {
      contestCount: 38,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 34000,
      percentageJoined: 90,
      isHotMatch: true,
    },
  },
  {
    id: "m43",
    teams: {
      home: {
        name: "Chennai Super Kings",
        code: "CSK",
        logo: "/team_logos/csk.jpeg",
      },
      away: {
        name: "Sunrisers Hyderabad",
        code: "SRH",
        logo: "/team_logos/srh.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "MA Chidambaram Stadium, Chennai",
    startTime: "Thu Apr 24 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Sunrisers Hyderabad won by 44 runs",
    scores: {
      home: "135/9 (20)",
      away: "179/5 (20)",
    },
    fantasy: {
      contestCount: 40,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 35000,
      percentageJoined: 90,
      isHotMatch: true,
    },
  },
  {
    id: "m44",
    teams: {
      home: {
        name: "Punjab Kings",
        code: "PBKS",
        logo: "/team_logos/pbks.jpeg",
      },
      away: {
        name: "Kolkata Knight Riders",
        code: "KKR",
        logo: "/team_logos/kkr.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "New PCA Stadium, Chandigarh",
    startTime: "Fri Apr 25 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Match abandoned due to rain",
    scores: {
      home: "201/4 (20)",
      away: "7/0 (1)",
    },
    fantasy: {
      contestCount: 38,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 34000,
      percentageJoined: 90,
      isHotMatch: true,
    },
  },
  {
    id: "m45",
    teams: {
      home: {
        name: "Mumbai Indians",
        code: "MI",
        logo: "/team_logos/mi.jpeg",
      },
      away: {
        name: "Lucknow Super Giants",
        code: "LSG",
        logo: "/team_logos/lsg.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Wankhede Stadium, Mumbai",
    startTime: "Sat Apr 26 2025 15:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Mumbai Indians won by 6 wickets",
    scores: {
      home: "165/4 (18.2)",
      away: "164/7 (20)",
    },
    fantasy: {
      contestCount: 36,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 31000,
      percentageJoined: 88,
      isHotMatch: true,
    },
  },
  {
    id: "m46",
    teams: {
      home: {
        name: "Delhi Capitals",
        code: "DC",
        logo: "/team_logos/dc.jpeg",
      },
      away: {
        name: "Royal Challengers Bengaluru",
        code: "RCB",
        logo: "/team_logos/rcb.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Arun Jaitley Stadium, Delhi",
    startTime: "Sat Apr 26 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Royal Challengers Bengaluru won by 6 wickets",
    scores: {
      home: "162/8 (20)",
      away: "163/4 (18.3)",
    },
    fantasy: {
      contestCount: 38,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 34000,
      percentageJoined: 90,
      isHotMatch: true,
    },
  },
  {
    id: "m47",
    teams: {
      home: {
        name: "Rajasthan Royals",
        code: "RR",
        logo: "/team_logos/rr.jpeg",
      },
      away: {
        name: "Gujarat Titans",
        code: "GT",
        logo: "/team_logos/gt.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Sawai Mansingh Stadium, Jaipur",
    startTime: "Sun Apr 27 2025 15:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Rajasthan Royals won by 7 wickets",
    scores: {
      home: "210/3 (15.5)",
      away: "209/6 (20)",
    },
    fantasy: {
      contestCount: 34,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 29000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m48",
    teams: {
      home: {
        name: "Delhi Capitals",
        code: "DC",
        logo: "/team_logos/dc.jpeg",
      },
      away: {
        name: "Kolkata Knight Riders",
        code: "KKR",
        logo: "/team_logos/kkr.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Arun Jaitley Stadium, Delhi",
    startTime: "Mon Apr 28 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "completed",
    result: "Kolkata Knight Riders won by 5 wickets",
    scores: {
      home: "170/6 (20)",
      away: "171/5 (19.2)",
    },
    fantasy: {
      contestCount: 36,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 31000,
      percentageJoined: 88,
      isHotMatch: true,
    },
  },
  {
    id: "m49",
    teams: {
      home: {
        name: "Chennai Super Kings",
        code: "CSK",
        logo: "/team_logos/csk.jpeg",
      },
      away: {
        name: "Punjab Kings",
        code: "PBKS",
        logo: "/team_logos/pbks.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "MA Chidambaram Stadium, Chennai",
    startTime: "Tue Apr 29 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 40,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 35000,
      percentageJoined: 90,
      isHotMatch: true,
    },
  },
  {
    id: "m50",
    teams: {
      home: {
        name: "Rajasthan Royals",
        code: "RR",
        logo: "/team_logos/rr.jpeg",
      },
      away: {
        name: "Mumbai Indians",
        code: "MI",
        logo: "/team_logos/mi.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Sawai Mansingh Stadium, Jaipur",
    startTime: "Wed Apr 30 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 38,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 34000,
      percentageJoined: 90,
      isHotMatch: true,
    },
  },
  {
    id: "m51",
    teams: {
      home: {
        name: "Gujarat Titans",
        code: "GT",
        logo: "/team_logos/gt.jpeg",
      },
      away: {
        name: "Sunrisers Hyderabad",
        code: "SRH",
        logo: "/team_logos/srh.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Narendra Modi Stadium, Ahmedabad",
    startTime: "Thu May 01 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 32,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 28000,
      percentageJoined: 85,
      isHotMatch: false,
    },
  },
  {
    id: "m52",
    teams: {
      home: {
        name: "Royal Challengers Bengaluru",
        code: "RCB",
        logo: "/team_logos/rcb.jpeg",
      },
      away: {
        name: "Chennai Super Kings",
        code: "CSK",
        logo: "/team_logos/csk.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "M Chinnaswamy Stadium, Bengaluru",
    startTime: "Fri May 02 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 42,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 38000,
      percentageJoined: 92,
      isHotMatch: true,
    },
  },
  {
    id: "m53",
    teams: {
      home: {
        name: "Kolkata Knight Riders",
        code: "KKR",
        logo: "/team_logos/kkr.jpeg",
      },
      away: {
        name: "Rajasthan Royals",
        code: "RR",
        logo: "/team_logos/rr.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Eden Gardens, Kolkata",
    startTime: "Sat May 03 2025 15:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 38,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 34000,
      percentageJoined: 90,
      isHotMatch: true,
    },
  },
  {
    id: "m54",
    teams: {
      home: {
        name: "Punjab Kings",
        code: "PBKS",
        logo: "/team_logos/pbks.jpeg",
      },
      away: {
        name: "Lucknow Super Giants",
        code: "LSG",
        logo: "/team_logos/lsg.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "HPCA Cricket Stadium, Dharamsala",
    startTime: "Sat May 03 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 32,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 28000,
      percentageJoined: 85,
      isHotMatch: false,
    },
  },
  {
    id: "m55",
    teams: {
      home: {
        name: "Sunrisers Hyderabad",
        code: "SRH",
        logo: "/team_logos/srh.jpeg",
      },
      away: {
        name: "Delhi Capitals",
        code: "DC",
        logo: "/team_logos/dc.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Rajiv Gandhi International Cricket Stadium, Hyderabad",
    startTime: "Sun May 04 2025 15:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 30,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 26000,
      percentageJoined: 80,
      isHotMatch: false,
    },
  },
  {
    id: "m56",
    teams: {
      home: {
        name: "Mumbai Indians",
        code: "MI",
        logo: "/team_logos/mi.jpeg",
      },
      away: {
        name: "Gujarat Titans",
        code: "GT",
        logo: "/team_logos/gt.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Wankhede Stadium, Mumbai",
    startTime: "Sun May 04 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 36,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 31000,
      percentageJoined: 88,
      isHotMatch: true,
    },
  },
  {
    id: "m57",
    teams: {
      home: {
        name: "Kolkata Knight Riders",
        code: "KKR",
        logo: "/team_logos/kkr.jpeg",
      },
      away: {
        name: "Chennai Super Kings",
        code: "CSK",
        logo: "/team_logos/csk.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Eden Gardens, Kolkata",
    startTime: "Mon May 05 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 40,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 35000,
      percentageJoined: 90,
      isHotMatch: true,
    },
  },
  {
    id: "m58",
    teams: {
      home: {
        name: "Punjab Kings",
        code: "PBKS",
        logo: "/team_logos/pbks.jpeg",
      },
      away: {
        name: "Delhi Capitals",
        code: "DC",
        logo: "/team_logos/dc.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "HPCA Cricket Stadium, Dharamsala",
    startTime: "Tue May 06 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 30,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 26000,
      percentageJoined: 80,
      isHotMatch: false,
    },
  },
  {
    id: "m59",
    teams: {
      home: {
        name: "Lucknow Super Giants",
        code: "LSG",
        logo: "/team_logos/lsg.jpeg",
      },
      away: {
        name: "Royal Challengers Bengaluru",
        code: "RCB",
        logo: "/team_logos/rcb.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "BRSABV Ekana Cricket Stadium, Lucknow",
    startTime: "Wed May 07 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 34,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 29000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m60",
    teams: {
      home: {
        name: "Mumbai Indians",
        code: "MI",
        logo: "/team_logos/mi.jpeg",
      },
      away: {
        name: "Kolkata Knight Riders",
        code: "KKR",
        logo: "/team_logos/kkr.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Wankhede Stadium, Mumbai",
    startTime: "Thu May 08 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 40,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 35000,
      percentageJoined: 90,
      isHotMatch: true,
    },
  },
  {
    id: "m61",
    teams: {
      home: {
        name: "Rajasthan Royals",
        code: "RR",
        logo: "/team_logos/rr.jpeg",
      },
      away: {
        name: "Sunrisers Hyderabad",
        code: "SRH",
        logo: "/team_logos/srh.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Sawai Mansingh Stadium, Jaipur",
    startTime: "Fri May 09 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 36,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 31000,
      percentageJoined: 88,
      isHotMatch: true,
    },
  },
  {
    id: "m62",
    teams: {
      home: {
        name: "Chennai Super Kings",
        code: "CSK",
        logo: "/team_logos/csk.jpeg",
      },
      away: {
        name: "Gujarat Titans",
        code: "GT",
        logo: "/team_logos/gt.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "MA Chidambaram Stadium, Chennai",
    startTime: "Sat May 10 2025 15:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 34,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 29000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m63",
    teams: {
      home: {
        name: "Delhi Capitals",
        code: "DC",
        logo: "/team_logos/dc.jpeg",
      },
      away: {
        name: "Mumbai Indians",
        code: "MI",
        logo: "/team_logos/mi.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Arun Jaitley Stadium, Delhi",
    startTime: "Sat May 10 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 38,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 34000,
      percentageJoined: 90,
      isHotMatch: true,
    },
  },
  {
    id: "m64",
    teams: {
      home: {
        name: "Royal Challengers Bengaluru",
        code: "RCB",
        logo: "/team_logos/rcb.jpeg",
      },
      away: {
        name: "Kolkata Knight Riders",
        code: "KKR",
        logo: "/team_logos/kkr.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "M Chinnaswamy Stadium, Bengaluru",
    startTime: "Sun May 11 2025 15:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 40,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 35000,
      percentageJoined: 90,
      isHotMatch: true,
    },
  },
  {
    id: "m65",
    teams: {
      home: {
        name: "Lucknow Super Giants",
        code: "LSG",
        logo: "/team_logos/lsg.jpeg",
      },
      away: {
        name: "Sunrisers Hyderabad",
        code: "SRH",
        logo: "/team_logos/srh.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "BRSABV Ekana Cricket Stadium, Lucknow",
    startTime: "Sun May 11 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 32,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 28000,
      percentageJoined: 85,
      isHotMatch: false,
    },
  },
  {
    id: "m66",
    teams: {
      home: {
        name: "Punjab Kings",
        code: "PBKS",
        logo: "/team_logos/pbks.jpeg",
      },
      away: {
        name: "Rajasthan Royals",
        code: "RR",
        logo: "/team_logos/rr.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "HPCA Cricket Stadium, Dharamsala",
    startTime: "Mon May 12 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 30,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 26000,
      percentageJoined: 80,
      isHotMatch: false,
    },
  },
  {
    id: "m67",
    teams: {
      home: {
        name: "Gujarat Titans",
        code: "GT",
        logo: "/team_logos/gt.jpeg",
      },
      away: {
        name: "Royal Challengers Bengaluru",
        code: "RCB",
        logo: "/team_logos/rcb.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Narendra Modi Stadium, Ahmedabad",
    startTime: "Tue May 13 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 34,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 29000,
      percentageJoined: 85,
      isHotMatch: true,
    },
  },
  {
    id: "m68",
    teams: {
      home: {
        name: "Mumbai Indians",
        code: "MI",
        logo: "/team_logos/mi.jpeg",
      },
      away: {
        name: "Chennai Super Kings",
        code: "CSK",
        logo: "/team_logos/csk.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Wankhede Stadium, Mumbai",
    startTime: "Wed May 14 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 45,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 40000,
      percentageJoined: 95,
      isHotMatch: true,
    },
  },
  {
    id: "m69",
    teams: {
      home: {
        name: "Kolkata Knight Riders",
        code: "KKR",
        logo: "/team_logos/kkr.jpeg",
      },
      away: {
        name: "Lucknow Super Giants",
        code: "LSG",
        logo: "/team_logos/lsg.jpeg",
      },
    },
    tournament: {
      name: "IPL 2025",
      shortName: "IPL",
    },
    venue: "Eden Gardens, Kolkata",
    startTime: "Thu May 15 2025 19:30:00 GMT+0530 (India Standard Time)",
    status: "upcoming",
    result: null,
    scores: {
      home: null,
      away: null,
    },
    fantasy: {
      contestCount: 36,
      prizePool: "700 USDC",
      entryFees: [49, 99, 499, 999],
      teamsCreated: 31000,
      percentageJoined: 88,
      isHotMatch: true,
    },
  },
  // {
  //   id: "m70",
  //   teams: {
  //     home: {
  //       name: "TBD",
  //       code: "TBD",
  //       logo: "/team_logos/tbd.jpeg",
  //     },
  //     away: {
  //       name: "TBD",
  //       code: "TBD",
  //       logo: "/team_logos/tbd.jpeg",
  //     },
  //   },
  //   tournament: {
  //     name: "IPL 2025",
  //     shortName: "IPL",
  //   },
  //   venue: "MA Chidambaram Stadium, Chennai",
  //   startTime: "Tue May 20 2025 19:30:00 GMT+0530 (India Standard Time)",
  //   status: "upcoming",
  //   result: null,
  //   scores: {
  //     home: null,
  //     away: null,
  //   },
  //   fantasy: {
  //     contestCount: 50,
  //     prizePool: "₹15 Lakh",
  //     entryFees: [49, 99, 499, 999],
  //     teamsCreated: 45000,
  //     percentageJoined: 95,
  //     isHotMatch: true,
  //   },
  // },
  // {
  //   id: "m71",
  //   teams: {
  //     home: {
  //       name: "TBD",
  //       code: "TBD",
  //       logo: "/team_logos/tbd.jpeg",
  //     },
  //     away: {
  //       name: "TBD",
  //       code: "TBD",
  //       logo: "/team_logos/tbd.jpeg",
  //     },
  //   },
  //   tournament: {
  //     name: "IPL 2025",
  //     shortName: "IPL",
  //   },
  //   venue: "Narendra Modi Stadium, Ahmedabad",
  //   startTime: "Wed May 21 2025 19:30:00 GMT+0530 (India Standard Time)",
  //   status: "upcoming",
  //   result: null,
  //   scores: {
  //     home: null,
  //     away: null,
  //   },
  //   fantasy: {
  //     contestCount: 50,
  //     prizePool: "₹15 Lakh",
  //     entryFees: [49, 99, 499, 999],
  //     teamsCreated: 45000,
  //     percentageJoined: 95,
  //     isHotMatch: true,
  //   },
  // },
  // {
  //   id: "m72",
  //   teams: {
  //     home: {
  //       name: "TBD",
  //       code: "TBD",
  //       logo: "/team_logos/tbd.jpeg",
  //     },
  //     away: {
  //       name: "TBD",
  //       code: "TBD",
  //       logo: "/team_logos/tbd.jpeg",
  //     },
  //   },
  //   tournament: {
  //     name: "IPL 2025",
  //     shortName: "IPL",
  //   },
  //   venue: "Narendra Modi Stadium, Ahmedabad",
  //   startTime: "Fri May 23 2025 19:30:00 GMT+0530 (India Standard Time)",
  //   status: "upcoming",
  //   result: null,
  //   scores: {
  //     home: null,
  //     away: null,
  //   },
  //   fantasy: {
  //     contestCount: 50,
  //     prizePool: "₹15 Lakh",
  //     entryFees: [49, 99, 499, 999],
  //     teamsCreated: 45000,
  //     percentageJoined: 95,
  //     isHotMatch: true,
  //   },
  // },
  // {
  //   id: "m73",
  //   teams: {
  //     home: {
  //       name: "TBD",
  //       code: "TBD",
  //       logo: "/team_logos/tbd.jpeg",
  //     },
  //     away: {
  //       name: "TBD",
  //       code: "TBD",
  //       logo: "/team_logos/tbd.jpeg",
  //     },
  //   },
  //   tournament: {
  //     name: "IPL 2025",
  //     shortName: "IPL",
  //   },
  //   venue: "MA Chidambaram Stadium, Chennai",
  //   startTime: "Sat May 24 2025 19:30:00 GMT+0530 (India Standard Time)",
  //   status: "upcoming",
  //   result: null,
  //   scores: {
  //     home: null,
  //     away: null,
  //   },
  //   fantasy: {
  //     contestCount: 50,
  //     prizePool: "₹15 Lakh",
  //     entryFees: [49, 99, 499, 999],
  //     teamsCreated: 45000,
  //     percentageJoined: 95,
  //     isHotMatch: true,
  //   },
  // },
  // {
  //   id: "m74",
  //   teams: {
  //     home: {
  //       name: "TBD",
  //       code: "TBD",
  //       logo: "/team_logos/tbd.jpeg",
  //     },
  //     away: {
  //       name: "TBD",
  //       code: "TBD",
  //       logo: "/team_logos/tbd.jpeg",
  //     },
  //   },
  //   tournament: {
  //     name: "IPL 2025",
  //     shortName: "IPL",
  //   },
  //   venue: "Narendra Modi Stadium, Ahmedabad",
  //   startTime: "Sun May 25 2025 19:30:00 GMT+0530 (India Standard Time)",
  //   status: "upcoming",
  //   result: null,
  //   scores: {
  //     home: null,
  //     away: null,
  //   },
  //   fantasy: {
  //     contestCount: 60,
  //     prizePool: "₹20 Lakh",
  //     // " Hawkins": true,
  //     entryFees: [49, 99, 499, 999, 1999],
  //     teamsCreated: 50000,
  //     percentageJoined: 98,
  //     isHotMatch: true,
  //   },
  // },
];

// Mock leagues data
export const leagues = [
  {
    id: "l1",
    name: "IPL Fantasy League",
    participants: 14726,
    prize: "1,000,000 USDC",
    startDate: "Apr 5, 2023",
    endDate: "May 28, 2023",
    joined: true,
    position: 456,
    userPoints: 1245,
  },
  {
    id: "l2",
    name: "World Cup Challenge",
    participants: 32190,
    prize: "2,500,000 USDC",
    startDate: "June 10, 2023",
    endDate: "July 15, 2023",
  },
  {
    id: "l3",
    name: "Friends Premier League",
    participants: 24,
    startDate: "Apr 8, 2023",
    endDate: "May 28, 2023",
    joined: true,
    position: 3,
    userPoints: 1567,
  },
];
